import { useEffect, useState } from 'react';

/**
 * A tela é estreita o bastante para o texto longo não caber?
 *
 * ── Por que existe ────────────────────────────────────────────────────────
 *
 * Os campos de escrever têm um exemplo no `placeholder`, e o exemplo é o que
 * ensina o que dá para escrever ali. Medido num Android de 360px, dois deles
 * não cabiam:
 *
 *   investimentos  "investi 5 mil em CDB no Nubank que rende 6% ao ano"
 *                  388px de texto numa caixa de 224
 *   dívidas        "registre uma dívida ou pergunte sobre as suas"
 *                  297px numa caixa de 226
 *
 * Placeholder cortado não é só feio: ele para no meio de uma frase que existe
 * para ser lida inteira, e o pedaço que some é justamente onde estava o
 * detalhe ("que rende 6% ao ano", "sobre as suas").
 *
 * ── Por que aqui e não no CSS ────────────────────────────────────────────
 *
 * `::placeholder` estiliza, não troca texto. Diminuir a fonte até caber deixa
 * ilegível o texto que a gente queria que fosse lido, e cortar com reticências
 * é o mesmo problema com outra aparência. Trocar a FRASE é a única saída que
 * mantém o exemplo legível.
 *
 * A versão longa continua nos chips de exemplo logo abaixo do campo — que é
 * onde ela cabe, porque lá o texto quebra em várias linhas.
 *
 * ── 480px ─────────────────────────────────────────────────────────────────
 *
 * O mesmo corte que o `App.css` já usa para o painel virar duas colunas. Um
 * segundo número aqui criaria uma faixa de larguras onde o layout é de celular
 * e o texto é de desktop.
 */
export const LARGURA_ESTREITA = 480;

export const useTelaEstreita = (): boolean => {
  const [estreita, setEstreita] = useState(
    () => typeof window !== 'undefined'
      && window.matchMedia(`(max-width: ${LARGURA_ESTREITA}px)`).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${LARGURA_ESTREITA}px)`);
    const ouvir = () => setEstreita(mq.matches);
    // Girar o aparelho troca a largura sem recarregar a página.
    mq.addEventListener('change', ouvir);
    ouvir();
    return () => mq.removeEventListener('change', ouvir);
  }, []);

  return estreita;
};
